import { Injectable, Inject } from '@angular/core';
import SHA1 from 'crypto-js/sha1';
import AES from 'crypto-js/aes';
import CryptoUTF8 from 'crypto-js/enc-utf8';
import { CookieService } from 'ngx-cookie-service';

interface RestrictedSession {
    token: string;
    refreshToken: string;
}

const privateSecretKey = '!T5a@Hh43%b$d3@2%a1#1gDe7Q@b1Qjl';

/**
 * Base para sessões de propósito restrito (contador, upload de certificado etc).
 *
 * Cada token de propósito restrito é gravado em um cookie próprio, isolado do
 * cookie de sessão do usuário logado (SessionService). Isso garante que entrar
 * ou sair de um fluxo de acesso temporário (ex.: link do portal do contador)
 * nunca sobrescreve nem interfere na sessão de um usuário já autenticado no app.
 */
export abstract class RestrictedSessionServiceBase {
    private session: RestrictedSession | undefined;

    protected abstract readonly cookieKeySeed: string;

    constructor(private cookieService: CookieService) { }

    private get CookieKey() {
        return SHA1(this.cookieKeySeed).toString();
    }

    private get SecretKey() {
        return SHA1(privateSecretKey).toString();
    }

    get isSet(): boolean {
        return this.cookieService.check(this.CookieKey);
    }

    setToken(session: RestrictedSession): void {
        this.session = session;
        this.cookieService.set(this.CookieKey, AES.encrypt(JSON.stringify(session), this.SecretKey).toString(), undefined, '/');
    }

    get token(): string {
        if (!this.session && this.isSet) {
            const json: string = this.cookieService.get(this.CookieKey);
            const bytes = AES.decrypt(json, this.SecretKey);
            this.session = JSON.parse(bytes.toString(CryptoUTF8));
        }
        return this.session?.token ?? '';
    }

    clear(): void {
        this.session = undefined;
        this.cookieService.delete(this.CookieKey, '/');
    }
}

@Injectable({
    providedIn: 'root'
})
export class AccountantSessionService extends RestrictedSessionServiceBase {
    protected readonly cookieKeySeed = 'aC7*nT4$dOr#Se55iOn!K3y2Fl1p3On';

    constructor(cookieService: CookieService) {
        super(cookieService);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CertificateSessionService extends RestrictedSessionServiceBase {
    protected readonly cookieKeySeed = 'C3rt1f1c@t3#Up10@d$S3ss10n!K3yF';

    constructor(cookieService: CookieService) {
        super(cookieService);
    }
}
